import './styles/index.scss';

import { initializeI18n, Locale, Realm } from './services/i18nService';
import React, { Suspense } from 'react';

import App from './components/App';
import ReactDOM from 'react-dom';
import { initializeSentry } from './services/sentryService';

import {
  AppShopContext,
  AppShopContextHolder,
  validateAppShopContext,
} from './components/context/AppShopContext';
import queryString from 'query-string';
import { init as initTesting } from './user-tracking';
import { initializeTheme } from './services/themeService';

// import reportWebVitals from './reportWebVitals';

initializeSentry('https://017bdbb9692f49ac8e09259209c17e75@o354215.ingest.sentry.io/5917370');

const container = document.getElementById('contact-form-ui') as HTMLElement;

// eslint-disable-next-line no-restricted-globals
const parsedQueryParams = queryString.parse(location.search);

const realm = (parsedQueryParams.realm || container.dataset.realm)! as Realm;
const locale = (parsedQueryParams.locale || container.dataset.locale)! as Locale;
const domain: string = (parsedQueryParams.domain || container.dataset.domain)! as string;
const siteId: number = +(parsedQueryParams.siteId || container.dataset.siteId)! as number;

initializeI18n(realm, locale);

const appShopContext: AppShopContextHolder = {
  siteId,
  locale,
  realm,
  domain,
};
validateAppShopContext(appShopContext);

initTesting();

initializeTheme(realm);

// Suspense for i18n initialization
ReactDOM.render(
  <React.StrictMode>
    <Suspense fallback={null}>
      <AppShopContext.Provider value={appShopContext}>
        <App />
      </AppShopContext.Provider>
    </Suspense>
  </React.StrictMode>,
  container,
);
